/** Backend stores user action turns as `[Action] {actionId}`. Map to readable chat labels. */
const AGENT_ACTION_USER_LABELS: Record<string, string> = {
  create_project_import: 'Create or Import Project',
  create_project_only: 'Create project',
  select_project: 'Select project',
  create_environment: 'Create Environment',
  apply_ordering: 'Apply suggested ordering',
  apply_default_headers: 'Apply default headers',
  apply_bearer: 'Apply Bearer token to requests',
  run_collection: 'Open Collections',
  store_credentials: 'Store credentials',
  add_environment_variable: 'Add environment variable',
  apply_environment_variables: 'Apply environment variables to request',
  apply_environment_variables_to_request: 'Apply environment variables to request',
  apply_credential_placeholders: 'Apply credential placeholders',
  suggest_datasets: 'Generate suggested assertions',
  guide_run: 'Guide run flow',
  run_full_flow: 'Run full flow',
  run_request_by_request: 'Run request by request',
  run_single_request: 'Execute request',
  collect_request_values: 'Provide required values',
  generate_fake_data: 'Generate fake data',
  run_round_robin: 'Run round robin',
};

function humanizeActionId(actionId: string): string {
  return actionId
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function formatAgentUserMessageText(text: string): string {
  if (!text) return text;
  const trimmed = text.trim();
  const match = trimmed.match(/^\[Action\]\s+(.+)$/i);
  if (!match) return text;
  const actionId = match[1].trim();
  return AGENT_ACTION_USER_LABELS[actionId] ?? humanizeActionId(actionId);
}

/** Normalize action button labels from backend or stored chat history. */
export function formatAgentActionLabel(actionId: string, fallbackLabel?: string): string {
  const trimmed = fallbackLabel?.trim();
  // Prefer the provided label so the same action id can power distinct buttons
  // (e.g. create_project_import → Create or Import Project vs Import Swagger).
  if (trimmed) {
    return trimmed;
  }
  return AGENT_ACTION_USER_LABELS[actionId] ?? humanizeActionId(actionId);
}
